module.exports = __webpack_public_path__ + "img/snooker.132e91a2.svg";